import { GridCellParams, GridColDef } from "@mui/x-data-grid";
import { DATE_FORMAT, GENERIC_MEMBER_STATUS_OPTIONS } from "constants/index";
import moment from "moment";

export const formatData = (data) => {
  return data.map((o, i) => {
    o.status = o.status
      ? GENERIC_MEMBER_STATUS_OPTIONS.find((f) => f.value === o.status)?.label || ""
      : "";

    // Helper to validate date
    const isValidDate = (d) => d && d !== "";

    o.status = o.status === "" ? "" : o.status;

    o.initial_appt_date = isValidDate(o.initial_appt_date)
      ? moment(o.initial_appt_date).format(DATE_FORMAT)
      : "";

    o.follow_up_appt_1 = isValidDate(o.follow_up_appt_1)
      ? moment(o.follow_up_appt_1).format(DATE_FORMAT)
      : isValidDate(o.initial_appt_date)
      ? moment(o.initial_appt_date).add(1, "d").format(DATE_FORMAT)
      : "";

    o.follow_up_appt_2 = isValidDate(o.follow_up_appt_2)
      ? moment(o.follow_up_appt_2).format(DATE_FORMAT)
      : isValidDate(o.follow_up_appt_1)
      ? moment(o.follow_up_appt_1).add(4, "w").format(DATE_FORMAT)
      : "";

    o.follow_up_appt_3 = isValidDate(o.follow_up_appt_3)
      ? moment(o.follow_up_appt_3).format(DATE_FORMAT)
      : isValidDate(o.follow_up_appt_2)
      ? moment(o.follow_up_appt_2).add(4, "w").format(DATE_FORMAT)
      : "";

    o.follow_up_appt_4 = isValidDate(o.follow_up_appt_4)
      ? moment(o.follow_up_appt_4).format(DATE_FORMAT)
      : isValidDate(o.follow_up_appt_3)
      ? moment(o.follow_up_appt_3).add(8, "w").format(DATE_FORMAT)
      : "";

    o.follow_up_appt_5 = isValidDate(o.follow_up_appt_5)
      ? moment(o.follow_up_appt_5).format(DATE_FORMAT)
      : isValidDate(o.follow_up_appt_4)
      ? moment(o.follow_up_appt_4).add(8, "w").format(DATE_FORMAT)
      : "";

    // o.pct_appt_completed_to_date =
    //   isFinite(o.pct_appt_completed_to_date) && o.pct_appt_completed_to_date !== -1
    //     ? Number(o.pct_appt_completed_to_date).toFixed(2)
    //     : "";

    o.follow_up_complete_percent = isFinite(o.follow_up_complete_percent)
      ? Number(o.follow_up_complete_percent).toFixed(2)
      : "0.00";

    o.id = i + 1;

    return o;
  });
};

export const columns: GridColDef[] = [
  {
    cellClassName: (params) => getCellClassName("member", params) + " MuiDataGrid-cell--textCenter",
    field: "member",
    // flex: 0.8,
    headerAlign: "center",
    headerName: "Member",
    type: "string",
    width: 170,
  },
  {
    cellClassName: (params) => getCellClassName("status", params) + " MuiDataGrid-cell--textCenter",
    field: "status",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Status",
    type: "string",
    width: 150,
  },
  {
    cellClassName: (params) => getCellClassName("initial_appt_date", params),
    field: "initial_appt_date",
    //flex: 0.12,
    headerName: "Initial Appt.",
    type: "string",
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_1", params),
    field: "follow_up_appt_1",
    //flex: 0.12,
    headerName: "Follow-up 1",
    type: "string",
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_2", params),
    field: "follow_up_appt_2",
    //flex: 0.12,
    headerName: "Follow-up 2",
    type: "string",
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_3", params),
    field: "follow_up_appt_3",
    //flex: 0.12,
    headerName: "Follow-up 3",
    type: "string",
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_4", params),
    field: "follow_up_appt_4",
    //flex: 0.12,
    headerName: "Follow-up 4",
    type: "string",
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_5", params),
    field: "follow_up_appt_5",
    //flex: 0.12,
    headerName: "Follow-up 5",
    type: "string",
  },
  // {
  //   cellClassName: (params) => getCellClassName("pct_appt_completed_to_date", params),
  //   field: "pct_appt_completed_to_date",
  //   //flex: 0.12,
  //   headerAlign: "right",
  //   headerName: "Pct Appts. Completed To Date",
  //   type: "number",
  // },
  // {
  //   cellClassName: (params) => getCellClassName("phone", params),
  //   field: "phone",
  //   //flex: 0.17,
  //   headerAlign: "center",
  //   headerName: "Phone",
  //   type: "string",
  //   width: 110,
  // },
  // {
  //   cellClassName: (params) => getCellClassName("email", params),
  //   field: "email",
  //   //flex: 0.2,
  //   headerAlign: "center",
  //   headerName: "Email",
  //   type: "string",
  //   width: 190,
  // },
  {
    cellClassName: (params) => getCellClassName("instructor_name", params),
    field: "instructor_name",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Instructor",
    type: "string",
    width: 170,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_count", params),
    field: "follow_up_appt_count",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "# Appts Possible",
    type: "number",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_missed_count", params),
    field: "follow_up_missed_count",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "# Appts Completed",
    type: "number",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_complete_percent", params),
    field: "follow_up_complete_percent",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Completer %",
    type: "number",
    width: 100,
  },
];

/** Function to update Style for row */
const getCellClassName = (field: String, params: GridCellParams<any, any, any>) => {
  let cellClass = "cell-print-class ";
  const isOddCell = (parseInt(params.id.toString()) + 1) % 2 !== 0;
  if (isOddCell) {
    cellClass += "odd-row";
  }

  //console.log("params", params);

  if (params.colDef.headerName === "Date Reached") {
    cellClass += " last-cell";
  }
  //console.log("params has:\n", params);
  if (field === "follow_up_appt_1" && params.row.follow_up_missed_1) {
    cellClass += " coach-approach-missed-appointment";
  }
  if (field === "follow_up_appt_2" && params.row.follow_up_missed_2) {
    cellClass += " coach-approach-missed-appointment";
  }
  if (field === "follow_up_appt_3" && params.row.follow_up_missed_3) {
    cellClass += " coach-approach-missed-appointment";
  }
  if (field === "follow_up_appt_4" && params.row.follow_up_missed_4) {
    cellClass += " coach-approach-missed-appointment";
  }
  if (field === "follow_up_appt_5" && params.row.follow_up_missed_5) {
    cellClass += " coach-approach-missed-appointment";
  }
  if (!params.row.member || params.row.member.toString().trim() === "") {
    cellClass += " coach-approach-aggregate-row ";
  }

  return cellClass;
};

export const generateCsvData = (data) => {
  const headerData = [
    [
      columns[0].headerName,
      columns[1].headerName,
      columns[2].headerName,
      columns[3].headerName,
      columns[4].headerName,
      columns[5].headerName,
      columns[6].headerName,
      columns[7].headerName,
      columns[8].headerName,
      columns[9].headerName,
      columns[10].headerName,
      columns[11].headerName,
    ],
  ];
  const rowData = data.map((x) => [
    x[columns[0].field],
    x[columns[1].field],
    x[columns[2].field],
    x[columns[3].field],
    x[columns[4].field],
    x[columns[5].field],
    x[columns[6].field],
    x[columns[7].field],
    x[columns[8].field],
    x[columns[9].field],
    x[columns[10].field],
    x[columns[11].field],
  ]);

  return headerData.concat(rowData);
};

const ExcelJS = require("exceljs");
export async function generateExcelFile(data, filename, spreadsheetName) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(spreadsheetName);
  worksheet.columns = columns.map((col) => ({
    header: col.headerName,
    key: col.field,
  }));
  data.forEach((row) => {
    const rowData = {};
    columns.forEach((col) => {
      rowData[col.field] = row[col.field];
    });
    const newRow = worksheet.addRow(rowData);
    columns.forEach((col, index) => {
      if (
        col.field.startsWith("follow_up_appt_") &&
        row[col.field.replace("appt", "missed")] === true
      ) {
        newRow.getCell(index + 1).font = { color: { argb: "FFFF0000" } };
      }
    });
  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const columnsForPdf: GridColDef[] = [
  {
    cellClassName: (params) => getCellClassName("member", params) + " MuiDataGrid-cell--textCenter",
    field: "member",
    headerAlign: "center",
    headerName: "Member",
    type: "string",
    width: 110,
  },
  {
    cellClassName: (params) => getCellClassName("status", params) + " MuiDataGrid-cell--textCenter",
    field: "status",
    headerAlign: "center",
    headerName: "Status",
    type: "string",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("initial_appt_date", params),
    field: "initial_appt_date",
    headerName: "Initial Appt.",
    type: "string",
    width: 80,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_1", params),
    field: "follow_up_appt_1",
    headerName: "Follow-up 1",
    type: "string",
    width: 77,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_2", params),
    field: "follow_up_appt_2",
    headerName: "Follow-up 2",
    type: "string",
    width: 77,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_3", params),
    field: "follow_up_appt_3",
    headerName: "Follow-up 3",
    type: "string",
    width: 77,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_4", params),
    field: "follow_up_appt_4",
    headerName: "Follow-up 4",
    type: "string",
    width: 77,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_5", params),
    field: "follow_up_appt_5",
    headerName: "Follow-up 5",
    type: "string",
    width: 77,
  },
  // {
  //   cellClassName: (params) => getCellClassName("pct_appt_completed_to_date", params),
  //   field: "pct_appt_completed_to_date",
  //   headerAlign: "right",
  //   headerName: "Pct Appts. Completed To Date",
  //   type: "number",
  //   width: 90,
  // },
  // {
  //   cellClassName: (params) => getCellClassName("phone", params),
  //   field: "phone",
  //   headerAlign: "center",
  //   headerName: "Phone",
  //   type: "string",
  //   width: 82,
  // },
  // {
  //   cellClassName: (params) => getCellClassName("email", params),
  //   field: "email",
  //   headerAlign: "center",
  //   headerName: "Email",
  //   type: "string",
  //   width: 130,
  // },
  {
    cellClassName: (params) => getCellClassName("instructor_name", params),
    field: "instructor_name",
    headerAlign: "center",
    headerName: "Instructor",
    type: "string",
    width: 110,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_count", params),
    field: "follow_up_appt_count",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "# Appts Possible",
    type: "number",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_missed_count", params),
    field: "follow_up_missed_count",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "# Appts Completed",
    type: "number",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_complete_percent", params),
    field: "follow_up_complete_percent",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Completer %",
    type: "number",
    width: 100,
  },
];

const TOTAL_COLUMNS = 12;
const SCREEN_WIDTH = 1700;

export const columnsForPrint: GridColDef[] = [
  {
    cellClassName: (params) => getCellClassName("member", params) + " MuiDataGrid-cell--textCenter",
    field: "member",
    headerAlign: "center",
    headerName: "Member",
    type: "string",
    width: 141.66,
  },
  {
    cellClassName: (params) => getCellClassName("status", params) + " MuiDataGrid-cell--textCenter",
    field: "status",
    headerAlign: "center",
    headerName: "Status",
    type: "string",
    width: 131.66,
  },
  {
    cellClassName: (params) => getCellClassName("initial_appt_date", params),
    field: "initial_appt_date",
    headerName: "Initial Appt.",
    type: "string",
    width: 121.66,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_1", params),
    field: "follow_up_appt_1",
    headerName: "Follow-up 1",
    type: "string",
    width: 111.66,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_2", params),
    field: "follow_up_appt_2",
    headerName: "Follow-up 2",
    type: "string",
    width: 111.66,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_3", params),
    field: "follow_up_appt_3",
    headerName: "Follow-up 3",
    type: "string",
    width: 111.66,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_4", params),
    field: "follow_up_appt_4",
    headerName: "Follow-up 4",
    type: "string",
    width: 111.66,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_5", params),
    field: "follow_up_appt_5",
    headerName: "Follow-up 5",
    type: "string",
    width: 111.66,
  },
  // {
  //   cellClassName: (params) => getCellClassName("pct_appt_completed_to_date", params),
  //   field: "pct_appt_completed_to_date",
  //   headerAlign: "right",
  //   headerName: "Pct Appts. Com. To Date",
  //   type: "number",
  //   width: 121.66,
  // },
  // {
  //   cellClassName: (params) => getCellClassName("phone", params),
  //   field: "phone",
  //   headerAlign: "center",
  //   headerName: "Phone",
  //   type: "string",
  //   width: 131.66,
  // },
  // {
  //   cellClassName: (params) => getCellClassName("email", params),
  //   field: "email",
  //   headerAlign: "center",
  //   headerName: "Email",
  //   type: "string",
  //   width: 161.66,
  // },
  {
    cellClassName: (params) => getCellClassName("instructor_name", params),
    field: "instructor_name",
    headerAlign: "center",
    headerName: "Instructor",
    type: "string",
    width: 141.66,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_appt_count", params),
    field: "follow_up_appt_count",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Follow Up Count",
    type: "number",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_missed_count", params),
    field: "follow_up_missed_count",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Follow Up Missed Count",
    type: "number",
    width: 100,
  },
  {
    cellClassName: (params) => getCellClassName("follow_up_complete_percent", params),
    field: "follow_up_complete_percent",
    //flex: 0.2,
    headerAlign: "center",
    headerName: "Pct Complete to Missed",
    type: "number",
    width: 100,
  },
];
